import { FaRobot } from 'react-icons/fa';
import type { CreditAnalysis } from './types';
import { AiResultBody, CloseButton, RecommendationBadge } from './components/AiResultDetails';
import ActionButton from './components/ActionButton';

// ═══════════════════════════════════════════════════════════════
// INTERFACES & TYPES
// ═══════════════════════════════════════════════════════════════

interface AiRationaleModalProps {
    row: CreditAnalysis | null;
    onClose: () => void;
}

// ═══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════

export default function AiRationaleModal({ row, onClose }: AiRationaleModalProps) {
    if (!row) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={onClose}>
            <div
                className="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="sticky top-0 bg-white dark:bg-slate-800 border-b border-gray-200 dark:border-slate-600 px-6 py-4 z-10 flex items-center justify-between shrink-0">
                    <div className="flex items-center gap-3 min-w-0">
                        <FaRobot className="text-purple-500 dark:text-purple-400 w-5 h-5 shrink-0" />
                        <div className="min-w-0">
                            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 truncate">{row.drawee}</h2>
                            <span className="text-xs text-gray-500 dark:text-gray-400">{row.document}</span>
                        </div>
                    </div>
                    <CloseButton onClose={onClose} />
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto p-6">
                    <AiResultBody
                        data={{
                            recommendation: row.aiRecommendation,
                            confidence: row.aiConfidence,
                            pdefault1y: row.aiPdefault1y,
                            rationale: row.aiRationale,
                            riskFactors: row.aiRiskFactors || [],
                            positiveFactors: row.aiPositiveFactors || [],
                            errorMessage: row.aiErrorMessage,
                        }}
                        leading={!row.aiErrorMessage && <RecommendationBadge recommendation={row.aiRecommendation} size="md" />}
                    />
                </div>

                {/* Footer */}
                <div className="border-t border-gray-200 dark:border-slate-600 px-6 py-3 flex justify-end shrink-0">
                    <ActionButton variant="cancel" size="sm" onClick={onClose}>
                        Fechar
                    </ActionButton>
                </div>
            </div>
        </div>
    );
}
